import { useCallback } from 'react';
import home from '~/assets/icons/home.svg';
import { playSound, Sound } from '~/assets/sounds';
import {
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import {
	setActiveMenu,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { StatusIcon } from '../StatusIcon';
import {
	StyledHeadContainer,
	StyledHeadingContainer,
	StyledHeadRightContainer,
} from './Head.styled';

const Head = () => {
	const dispatch = useLayoutDispatch();
	const houseData = useLayoutSelector((state) => state.homeBuying.houseData);
	const activeMenu = useLayoutSelector((state) => state.homeBuying.activeMenu);
	const modalState = useObservable(rage.modal.getCurrentModal());

	const toggleLockHouse = useCallback(() => {
		const houseData = rage.houses.getCurrentHouse().getValue();
		if (houseData?.isOwned) {
			rage.houses
				.setHouseLocked(houseData.id, !houseData.isLocked)
				.catch((err) => rage.notifications.showException(err));
		}
	}, [houseData]);

	useInputAction(InputAction.CommonMenuClose, () => {
		if (modalState) {
			return;
		}

		if (activeMenu === 'sell') {
			dispatch(setActiveMenu('home'));
			return;
		}

		rage.houses
			.exitMenu()
			.catch((err) => rage.notifications.showException(err));
	});

	return (
		<StyledHeadContainer>
			<StyledHeadingContainer>
				<img src={home} width={20} height={20} />
				<Text style={{ fontSize: 18, fontWeight: 700, color: '#FFFFFF' }}>
					Дом #{houseData?.id}
				</Text>
			</StyledHeadingContainer>
			<StyledHeadRightContainer>
				<StyledHeadingContainer $hidden={!houseData?.isOwned}>
					<Text
						style={{
							fontSize: 14,
							fontWeight: 500,
							color: '#FFFFFF',
							opacity: houseData?.isLocked ? 0.5 : 1,
						}}
					>
						{houseData?.isLocked ? 'Дверь закрыта' : 'Дверь открыта'}
					</Text>
					<StatusIcon
						active={!houseData?.isLocked}
						onClick={() => {
							toggleLockHouse();
							if (houseData?.isOwned) {
								playSound(Sound.ClickButton);
							}
						}}
						style={{ pointerEvents: houseData?.isOwned ? 'auto' : 'none' }}
						onMouseEnter={() => {
							if (houseData?.isOwned) {
								playSound(Sound.LinkCursor);
							}
						}}
					/>
				</StyledHeadingContainer>
				<CloseButton
					color={ButtonColors.Default}
					height={ButtonHeight.Height20}
					onClick={() =>
						rage.houses
							.exitMenu()
							.catch((err) => rage.notifications.showException(err))
					}
					borderRadius={ButtonBorderRadius.Radius5}
					iconSize={10}
				/>
			</StyledHeadRightContainer>
		</StyledHeadContainer>
	);
};

export { Head };
